import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import { Button } from "semantic-ui-react";
import { getSubdomain } from "../config/StylesheetInjector";
import imageRegistry from "../constants/imageRegistry";
import { handleSaveAndExit } from "../helpers/common";
import { ErrorBoundaryProvider } from "../providers/ErrorBoundaryProvider";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { t } = this.props;

    console.log(t("error"), error);
    console.log(t("errorInfo"), errorInfo);
  }

  render() {
    const { t } = this.props;
    const sub = getSubdomain();

    if (this.state.hasError || this.props.isRouteMissing) {
      return (
        <ErrorBoundaryProvider hasError={true}>
          <div className="errorContainer">
            <ReactSVG src={imageRegistry[sub]} />
            <h1>{t("errorHeader")}</h1>
            <p>{t("errorSubHeader")}</p>
            <Button
              onClick={() => handleSaveAndExit()}
              className="errorpage__go-dashboard "
            >
              {t("home:gotoDashboard")}
            </Button>
          </div>
        </ErrorBoundaryProvider>
      );
    }

    return (
      <ErrorBoundaryProvider hasError={false}>
        {this.props.children}
      </ErrorBoundaryProvider>
    );
  }
}

export default withTranslation("errorBoundary")(ErrorBoundary);
